export enum InformationKinds {
  All = 1,
  Patient = 2,
  User = 3,
  Medical = 4,
  Insurance = 5,
  Disease = 6,
  Hospitalization = 7,
  Operation = 8,
  Hospital = 9,
  Report = 10,
  Workflow = 11,
  Lis = 12,
  General = 13,
  Rehabili = 14,
  Host = 15,
}
